<mat-form-field2 class="mat-block" [showLabel]="showLabel" [hidePlaceholder]="showPlaceholder === false">
  <mat-label *ngIf="label">
    {{ label }}
    <i [ngClass]="infoIcon" *ngIf="infoIcon"></i>
  </mat-label>
  <app-select
    [items]="rentals$ | async"
    [formControl]="ctrl"
    [bindLabel]="getRentalLabel"
    [bindValue]="bindValue"
    [multiple]="multiple"
    [searchable]="true"
    [showBlankItem]="showBlankItem"
    [required]="ctrl | required"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [showMasterCheckbox]="showMasterCheckbox"
    [showCloseButton]="showCloseButton"
    (openedChange)="openedChange.emit($event)"
    (selectionChange)="selectedValuesChange.emit($event)"
    (selectedChange)="selectedItemsChange.emit($event)"
    [isSelectable]="isSelectable"
    [bindTooltip]="getTooltip"
  >
    <ng-template selectItem let-item="item" let-label="label">
      {{ label }}
      <span class="text-muted text-sm" *ngIf="isMainUnit | call : item" i18n>(Main Unit)</span>
      <span class="text-muted text-sm" *ngIf="isSubunit | call : item" i18n>(Subunit)</span>
    </ng-template>
  </app-select>
  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
    {{ placeholder }}<ng-container i18n> is required</ng-container>
  </mat-error>
  <mat-error *ngIf="ctrl.hasError('atLeast')" i18n>You must select at least 2 rentals</mat-error>
</mat-form-field2>
